

















import globalConfig from "@/globals/Configuration";
import { Component, Vue, Prop } from "vue-property-decorator";
import NavigationBreadcrumb, { BreadcrumbItem } from "@/components/apps/NavigationBreadcrumb.vue";
import LoadingStore from "@/store/modules/loading";
import { getModule } from "vuex-module-decorators";
const loadingStore = getModule(LoadingStore);

@Component({
  components: { NavigationBreadcrumb }
})
export default class Header extends Vue {
  @Prop()
  breadcrumbItems!: BreadcrumbItem[];

  get headerHeight(): string {
    return `${globalConfig.offsets.appHeader}px`;
  }

  get loading() {
    return loadingStore.isLoading;
  }
}
